module.exports = __webpack_public_path__ + "img/hero-bg.158d1b11.webp";